import { render, staticRenderFns } from "./interact-comment.vue?vue&type=template&id=2f0dde0f&scoped=true"
import script from "./interact-comment.vue?vue&type=script&lang=js"
export * from "./interact-comment.vue?vue&type=script&lang=js"
import style0 from "./interact-comment.vue?vue&type=style&index=0&id=2f0dde0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0dde0f",
  null
  
)

export default component.exports